import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
} from "@chakra-ui/react";
import { FC } from "react";

type CustomDrawerProps = {
  placement: "right" | "bottom";
  bg?: string;
  isOpen: boolean;
  h?: any;
  size?: string;
  drawerBodyHeight?: string;
  onClose: () => void;
  content: JSX.Element;
  borderTopRadius?: any;
  borderRadius?: any;
  closeOnEsc?: boolean;
  closeOnOverlayClick?: boolean;
};

const CustomDrawer: FC<CustomDrawerProps> = ({
  bg,
  isOpen,
  onClose,
  placement,
  content,
  h,
  size = "md",
  closeOnEsc,
  closeOnOverlayClick,
  borderTopRadius,
  borderRadius,
  drawerBodyHeight,
}) => {
  return (
    <Drawer
      closeOnEsc={closeOnEsc}
      closeOnOverlayClick={closeOnOverlayClick}
      isOpen={isOpen}
      placement={placement}
      size={size}
      onClose={onClose}
    >
      <DrawerOverlay bg={"rgba(0, 0, 0, 0.50)"} backdropFilter={"blur(10px)"} />
      <DrawerContent
        bg={bg || "#fff"}
        color={"#000"}
        h={h}
        borderTopRadius={borderTopRadius ?? { base: "40px", md: "none" }}
        borderRadius={borderRadius}
        className={"no-scrollbar"}
        fontFamily={"font4"}
        p={{base: "0.675rem", md: "1rem"}}
      >
        {content}
        {/* <DrawerBody px={4} h={drawerBodyHeight}></DrawerBody> */}
      </DrawerContent>
    </Drawer>
  );
};

export default CustomDrawer;
